<script lang="ts" setup>
import { Workshop } from '@/@types/workshop'
import video from '@/assets/main/video.mp4'
import second from '@/assets/show/image-1.webp'
import third from '@/assets/show/image-2.webp'
import four from '@/assets/show/image-3.webp'
import first from '@/assets/show/image.webp'
import { event_end_day, event_month, event_start_day, event_year } from '@/helpers/event-date'

defineProps<{
    workshop: Workshop
}>()
</script>

<template>
    <section>
        <div class="relative z-20 flex flex-col-reverse gap-2 sm:gap-6 md:flex-row lg:gap-12">
            <div class="relative h-64 w-full rounded-2xl sm:max-w-64 lg:h-[458px] lg:max-w-[458px]">
                <video
                    class="absolute inset-0 h-full w-full rounded-2xl bg-black"
                    autoplay
                    muted
                    loop
                    controlsList="nofullscreen"
                    playsinline
                    preload="none"
                >
                    <source :src="video" type="video/mp4" />
                </video>
            </div>

            <div class="flex flex-1 flex-col justify-between gap-8 text-white">
                <div class="lg:mt-12">
                    <p
                        v-html="
                            $t('event_date', {
                                start: event_start_day(workshop.event_start_date),
                                end: event_end_day(workshop.event_end_date),
                                month: event_month(workshop.event_start_date),
                                year: event_year(workshop.event_start_date),
                            })
                        "
                    ></p>
                    <h1 class="text-title font-bold">{{ $t('International Supply Chain Forum & Expo.Logistics') }}</h1>
                    <p>
                        {{
                            $t(
                                'The event that is transforming Brazilian logistics is back. Join the ILOS Forum, the largest national meeting of executives, experts and decision-makers in logistics, supply chain and transportation. There will be two intense days with exclusive content, real cases, global trends and practical strategies that you can immediately apply in your company. All of this presented by those who lead the sector.',
                                { event_description: $t(workshop.description) },
                            )
                        }}
                    </p>
                </div>

                <div class="grid grid-cols-4 gap-2 sm:gap-4">
                    <img :src="first" alt="" class="aspect-square h-full w-full rounded-2xl object-cover" />
                    <img :src="second" alt="" class="aspect-square h-full w-full rounded-2xl object-cover" />
                    <img :src="third" alt="" class="aspect-square h-full w-full rounded-2xl object-cover" />
                    <img :src="four" alt="" class="aspect-square h-full w-full rounded-2xl object-cover" />
                </div>
            </div>
        </div>
    </section>
</template>
